export default [{
    chave: 'ESCLARECIMENTO',
    label: 'Esclarecimento'
}, {
    chave: 'IMPUGNACAO',
    label: 'Impugnação'

}]
